import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import validate from './validate';
import { renderField, renderHidden, renderSelect, renderTextarea } from '../../../utils/renderFields';
import { sendBroadcastRequest, sendTemplateRequest } from '../../../actions/auth';
import { isSubdomain } from '../../../utils';

const propTypes = {
  closeModal: PropTypes.func,
};

const defaultProps = {
  closeModal: () => {
  },
};

class BroadcastToFacebookForm extends React.Component {

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.afterSuccess = this.afterSuccess.bind(this);
  }

  afterSuccess() {
    const { fetchTemplate, livecamId, closeModal } = this.props;
    setTimeout(() => {
      fetchTemplate(livecamId);
      closeModal();
    }, 3000);
  }

  submit(values) {
    const { broadcast } = this.props;
    return broadcast(values, this.afterSuccess);
  }

  render() {
    const { error, handleSubmit, submitting, submitSucceeded, livecamTitle } = this.props;
    if (submitSucceeded) {
      return (
        <div className="text-center">
          <p><strong>{livecamTitle}</strong> will now be broadcast to Facebook Live!</p>
        </div>
      );
    }
    const options = isSubdomain ? [
      { value: 'explore', label: 'Explore Live Cams (Beta)' },
    ] : [
      { value: 'explore', label: 'Explore.org' },
      { value: 'dog-bless', label: 'Dog Bless You' },
    ];
    return (
      <div className="p-20">
        <p>To send <strong>{livecamTitle}</strong> to Facebook Live, fill out the following information.</p>
        {!!isSubdomain && (
          <p className="alert alert-dark">
            Facebook Live broadcast is in test mode. The stream that will be sent to the testing
            Facebook page will be from the staging cameras, not necessarily the one you see here.
          </p>
        )}
        <form onSubmit={handleSubmit(this.submit)}>
          <span className="u-fontSize-11">{error}</span>
          <Field
            component={renderTextarea}
            name="description"
            label="Enter a description for the broadcast"
            className="form-control"
          />
          <Field
            component={renderSelect}
            name="fb_page"
            label="Select Facebook page"
            options={options}
            className="form-control"
            noPlaceholder
          />
          <Field
            name="duration"
            className="form-control"
            type="number"
            component={renderField}
            label="Duration (in minutes)"
          />
          <Field component={renderHidden} name="token" />
          <input type="submit" value="Submit" className="btn btn-primary" disabled={submitting} />
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    livecamTitle: state.currentItem.data.title,
    livecamId: state.currentItem.data.id,
    closeModal: ownProps.closeModal,
    initialValues: {
      duration: 10,
      streamId: state.currentItem.data.stream_id,
      fb_page: 'explore',
      description: state.auth.template.text,
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTemplate: id => dispatch(sendTemplateRequest(id)),
    broadcast: (values, callback) => dispatch(sendBroadcastRequest(values, callback)),
  };
};

BroadcastToFacebookForm.propTypes = propTypes;
BroadcastToFacebookForm.defaultProps = defaultProps;

const BroadcastToFacebookFormWrapped = reduxForm({
  form: 'broadcast-to-facebook',
  validate,
  fields: ['description', 'fb_page', 'duration', 'streamId'],
  enableReinitialize: true,
})(BroadcastToFacebookForm);

export default connect(mapStateToProps, mapDispatchToProps)(BroadcastToFacebookFormWrapped);
